import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatSidenavModule } from '@angular/material/sidenav';
import { AllowedDirective } from '../../shared/services/directives/allowed.directive';

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [RouterModule, MatSidenavModule, AllowedDirective],
  templateUrl: './registration.component.html',
  styleUrl: './registration.component.scss',
})
export class RegistrationComponent {}
